function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "streamicon",
  transform: "translate(-5.142 -52.21)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1702",
  "data-name": "Grupo 1702",
  transform: "translate(5.442 52.51)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1133",
  "data-name": "Caminho 1133",
  d: "M16.321,60H2.576V52.51H16.321Zm-13.5-.292H16.081V52.8H2.816Z",
  transform: "translate(-2.576 -52.51)",
  fill: "none",
  stroke: "#d28000",
  strokeWidth: 0.6
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1703",
  "data-name": "Grupo 1703",
  transform: "translate(18.945 53.278)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1134",
  "data-name": "Caminho 1134",
  d: "M117.736,64.81l-2.5-1.535V60.386l2.5-1.535Zm-2.255-1.729,2.013,1.238V59.342L115.48,60.58Z",
  transform: "translate(-115.238 -58.851)",
  fill: "none",
  stroke: "#d28000",
  strokeWidth: 0.6
})));

function SvgStreamicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.6,
    height: 8.095,
    viewBox: "0 0 16.6 8.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamicon);
export default __webpack_public_path__ + "static/media/streamicon.8109f094.svg";
export { ForwardRef as ReactComponent };